/* eslint-disable react/jsx-indent, react/jsx-props-no-spreading */
import classNames from 'classnames';
// import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import { stringify } from 'query-string';
// import { parse as parseQuery, stringify as stringifyQuery } from 'query-string';
import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react';

import useElementSize from '../../hooks/useElementSize';
// import { useItemsPaginated } from '../../hooks/useItems';
import useItemsStore from '../../hooks/useItemsStore';
import useWindowSize from '../../hooks/useWindowSize';

import { useApi } from '../../contexts/ApiContext';
import { useEdition } from '../../contexts/EditionContext';
// import { useList } from '../../contexts/ListsContext';
import { useModal } from '../../contexts/ModalsContext';
import FiltersButton from '../buttons/FiltersButton';
import Card from '../cards/Card';
import ActiveFiltersButtons from '../partials/ActiveFiltersButtons';
import Filters from '../partials/Filters';
import NoEvents from '../partials/NoEvents';
import NoFilms from '../partials/NoFilms';
import NoResults from '../partials/NoResults';
import LoadingList from './LoadingList';

import styles from '../../../styles/lists/index-list.module.scss';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    header: PropTypes.node,
    section: PropTypes.shape({
        url: PropTypes.string,
    }),
    repository: PropTypes.string.isRequired,
    itemType: PropTypes.string,
    cardType: PropTypes.string,
    cardComponent: PropTypes.elementType,
    cardProps: PropTypes.objectOf(PropTypes.any), // eslint-disable-line react/forbid-prop-types
    listComponent: PropTypes.elementType,
    listProps: PropTypes.objectOf(PropTypes.any), // eslint-disable-line react/forbid-prop-types
    emptyElement: PropTypes.node,
    filters: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
    query: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    initialPages: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
    onQueryChange: PropTypes.func,
    onQueryReset: PropTypes.func,
    onItemTypeChange: PropTypes.func,
    withPlaceholderIndex: PropTypes.bool,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    isGrid: PropTypes.bool,
    isDark: PropTypes.bool,
};

const defaultProps = {
    title: null,
    url: null,
    header: null,
    section: null,
    itemType: null,
    cardType: null,
    cardComponent: null,
    cardProps: null,
    listComponent: null,
    listProps: null,
    emptyElement: null,
    filters: null,
    query: {},
    initialPages: null,
    onQueryChange: null,
    onQueryReset: null,
    onItemTypeChange: null,
    withPlaceholderIndex: true,
    className: null,
    itemClassName: null,
    isGrid: false,
    isDark: false,
};

const IndexList = ({
    title,
    url,
    header,
    section,
    repository,
    itemType,
    cardType,
    cardComponent,
    cardProps,
    listComponent: ListComponent,
    listProps,
    emptyElement: customEmptyElement,
    filters,
    query,
    initialQuery,
    initialPages,
    onQueryChange,
    onQueryReset,
    onItemTypeChange,
    withPlaceholderIndex,
    className,
    itemClassName,
    isGrid,
    isDark,
}) => {
    const ref = useRef();
    const api = useApi();
    const { setModal } = useModal();
    const { width: windowWidth } = useWindowSize();
    const {
        current: currentEdition = false,
        ended: endedEdition = false,
        handle = null,
    } = useEdition();

    const mainRef = useRef(null);
    const { current } = mainRef || null;
    const { width: gridWidth = null } = useElementSize(current);

    // console.log('withPlaceholderIndex', withPlaceholderIndex);

    let columns = null;
    if (gridWidth !== null) {
        columns = 1;
        if (gridWidth >= 320) {
            columns = 2;
        }
        if (gridWidth >= 500) {
            columns = 3;
        }
        if (gridWidth >= 768) {
            columns = 4;
        }
        if (gridWidth >= 1060) {
            columns = 5;
        }
        if (gridWidth >= 1600) {
            columns = 6;
        }
    }

    const getPage = useCallback(
        (page, count) => {
            // Exception because name clashes with pages api
            const repo = repository === 'pages' ? 'pageSearch' : repository;
            return api[repo]
                .get(
                    {
                        ...query,
                        page,
                        count,
                    },
                    `${url}.json`,
                )
                .then((response) => {
                    const { pages = [], itemType: responseItemType = null } = response || {};
                    if (onItemTypeChange !== null) {
                        onItemTypeChange(responseItemType);
                    }
                    const [currentPage = null] = pages || [];
                    return currentPage || null;
                });
        },
        [api, repository, query, url, onItemTypeChange],
    );

    // console.log('repository', repository, itemType);

    const {
        // search = null,
        page: queryPage = 1,
        count: queryCount = 10,
        ...otherQuery
    } = query || {};

    const listKey = useMemo(
        () => stringify({ ...query, repository, url }),
        [query, repository, url],
    );

    // console.log('repository', repository, 'listKey', listKey);
    // const { list, setList } = useList(listKey);
    // const [finalInitialPages, setFinalInitialPages] = useState();

    // useEffect(() => {
    // setFinalInitialPages(list !== null ? list : initialPages);
    // }, [listKey, setFinalInitialPages, cardType]);

    const {
        allItems: items,
        loading,
        allLoaded,
        loadNextPage,
        // pages: paginatedPages,
    } = useItemsStore(itemType === 'section' ? 'section' : repository, {
        getPage,
        query,
        onQueryChange,
        page: queryPage,
        keepData: false,
        // placeholderData: initialPages,
        count: queryCount,
        listKey,
    });

    // console.log('items', items);
    // useEffect(() => {
    //     if (isArray(paginatedPages)) {
    //         setList(
    //             paginatedPages
    //                 .map((paginatedPage) => {
    //                     const { items: newItems = null, ...pagination } = paginatedPage || {};
    //                     const { page, lastPage, total } = pagination || {};
    //                     if (newItems !== null) {
    //                         return {
    //                             data: newItems,
    //                             pagination: {
    //                                 page,
    //                                 last_page: lastPage,
    //                                 total,
    //                                 per_page: queryCount,
    //                             },
    //                         };
    //                     }
    //                     return null;
    //                 })
    //                 .filter((it) => it != null),
    //         );
    //     }
    // }, [paginatedPages]);

    const [filtersOpened, setFiltersOpened] = useState(false);
    const toggleFilters = useCallback(() => {
        setFiltersOpened(!filtersOpened);
    }, [filtersOpened, setFiltersOpened]);

    const onClickEnd = useCallback(() => {
        // console.log('scroll to top');
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    });

    const { dates = null } = query || {};
    const emptyElement =
        cardType === 'event' && dates === null ? (
            <NoEvents isDark={isDark} />
        ) : (
            <NoResults isDark={isDark} />
        );

    const partialEmptyElement = cardType === 'film' ? <NoFilms isDark={isDark} /> : emptyElement;
    const finalEmptyElement = customEmptyElement || partialEmptyElement;

    useEffect(() => {
        document.body.style.overflow = filtersOpened ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [filtersOpened]);

    useEffect(() => {
        setFiltersOpened(false);
    }, [filters, windowWidth]);

    const { parent = null } = cardProps || {};
    const headingProps = useMemo(() => {
        const {
            title: parentTitle = null,
            description = null,
            url: parentUrl = null,
            type,
        } = section || parent || {};

        return {
            title: title || parentTitle,
            description,
            url: parentUrl,
            type,
            query: otherQuery,
            filters,
        };
    }, [title, parent, filters, otherQuery, section]);

    const openFilmModal = useCallback(
        (item, props) => {
            setModal({
                type: 'films',
                item,
                fullScreen: true,
                loadNextPage,
                allLoaded,
                listKey: cardType !== 'section' ? listKey : null,
                items,
                heading: headingProps,
                withAutoScroll: cardType !== 'section',
                withoutTitleBar: true,
                ...props,
            });
        },
        [setModal, items, query, filters, loadNextPage, headingProps, allLoaded],
    );

    const calendarFilter = (filters || []).find(({ type = null }) => type === 'calendar');
    const { dates: stickyDates = null } = calendarFilter || {};

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.filtersOpened]: filtersOpened,
                    [styles.withSticky]: stickyDates !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <aside className={styles.sidePanel}>
                    <div className={styles.sidePanelInner} ref={ref}>
                        <Filters
                            className={styles.sidePanelFilters}
                            innerClassName={styles.sidePanelFields}
                            isOpenClassName={styles.filterIsOpen}
                            itemWrapperClassName={styles.filterItemWrapper}
                            filters={filters}
                            query={query}
                            initialQuery={initialQuery}
                            onChange={onQueryChange}
                            onApply={toggleFilters}
                            onReset={onQueryReset}
                            filterProps={
                                cardType === 'event' && currentEdition && !endedEdition
                                    ? { initialValue: `${handle}-10-02` }
                                    : null
                            }
                        />
                    </div>
                </aside>
                <main
                    className={classNames(styles.main, {
                        [styles.withSticky]: stickyDates !== null,
                        [styles.empty]: (items || []).length === 0 && !loading,
                    })}
                    ref={mainRef}
                >
                    <FiltersButton
                        className={styles.filtersBtn}
                        opened={filtersOpened}
                        onClick={toggleFilters}
                    />
                    {header}
                    <ActiveFiltersButtons
                        className={styles.activeFilters}
                        filters={filters}
                        query={query}
                        onChange={onQueryChange}
                        onReset={onQueryReset}
                        isDark={isDark}
                    />
                    {(items || []).length === 0 && !loading ? (
                        <div className={styles.emptyElement}>{finalEmptyElement}</div>
                    ) : (
                        <LoadingList
                            loading={loading}
                            ended={allLoaded && !loading}
                            isGrid={isGrid}
                            gridColumns={cardType === 'film' ? columns : null}
                            onClickMore={loadNextPage}
                            onClickEnd={onClickEnd}
                            className={classNames({
                                [styles.items]: cardType === 'film',
                            })}
                            withMore
                            withAutoLoad
                        >
                            {ListComponent !== null ? (
                                <ListComponent
                                    items={items}
                                    loading={loading}
                                    lazyLoad={false}
                                    onQueryChange={onQueryChange}
                                    onQueryReset={onQueryReset}
                                    isIndex
                                    withStickyHeader
                                    isDark={isDark}
                                    {...listProps}
                                />
                            ) : (
                                (items || []).map((item, itemIndex) => (
                                    <div
                                        key={item.id}
                                        className={classNames([
                                            {
                                                [styles.item]: isGrid,
                                                [styles.group]: !isGrid,
                                                [itemClassName]: itemClassName !== null,
                                            },
                                        ])}
                                    >
                                        <Card
                                            className={styles.card}
                                            item={item}
                                            type={cardType}
                                            component={cardComponent}
                                            openFilmModal={openFilmModal}
                                            withoutShortTitle // For shorts sections only
                                            placeholderIndex={
                                                withPlaceholderIndex ? itemIndex : null
                                            }
                                            {...cardProps}
                                        />
                                    </div>
                                ))
                            )}
                        </LoadingList>
                    )}
                </main>
            </div>
        </div>
    );
};

IndexList.propTypes = propTypes;
IndexList.defaultProps = defaultProps;

export default IndexList;
